<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Clients",
          icon: "bi bi-people-fill",
          route: "customers-index",
        },
        {
          label: "Nouveau client",
          icon: "bi bi-person-plus-fill",
          route: "customers-create",
        },
        {
          label: "Types de comptes",
          icon: "bi bi-diagram-3-fill",
          route: "customers-types-index",
        },
        {
          label: "Vendeurs liés",
          icon: "bi bi-person-badge-fill",
          route: "customers-sellers-index",
        },
      ],
    };
  },
};
</script>
